import { createSvg } from '../createSvg';
var RotateLeft = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1.5 : _b;
    return <g id={'contour'}>
        <path d='M9.11008 5.08C9.98008 4.82 10.9401 4.65 12.0001 4.65C16.7901 4.65 20.6701 8.53 20.6701 13.32C20.6701
                 18.11 16.7901 21.99 12.0001 21.99C7.21008 21.99 3.33008 18.11 3.33008 13.32C3.33008 11.54 3.87008 9.88
                 4.79008 8.5' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        <path d='M7.87012 5.32L10.7601 2' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        <path d='M7.87012 5.32L11.2401 7.78' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
    </g>;
};
export default createSvg(RotateLeft, 'rotate-left');
